// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3D3Gh","right":"styles_right__1K5xr"};